import React from 'react';
import styled from 'styled-components';

export default function PointReasonInput(props) {
  const { value, setValue } = props;

  function handleChange(e) {
    setValue(e.target.value);
  }

  function handleFocus() {
    
  }

  function handleBlur() {
    
  }

  return (
    <TopLevelWrapper>
      <Input 
        // ref={InputRef}
        placeholder='적용 내용을 적어주세요'
        value={value || ''}
        onFocus={handleFocus}
        onChange={handleChange}
        onBlur={handleBlur}/>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const Input = styled.textarea`
  width: calc(100% - 20px);
  height: 17px;
  // height: 52px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  padding: 10px;

  border: 1px solid #DFDFDF;
  border-radius: 5px;
  outline: none;

  color: #333333;
  background-color: #FFFFFF;

  resize: none;

  ::placeholder {
    color: #CBCBCB;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
`;